import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { Button } from '../../../../common/html/button'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../helpers/EventEmitter'
import { isObjectEqual } from '../../../../helpers/common'
import AlertSettingService from '../../core/AlertSettingService'
import { selectAllExistNames, selectProfileById } from '../../store/slice'
import { getAlertSettingsDynamic } from '../../store/thunk'
import { CREATE_EDIT_PROFILE_SCROLL_ID, ERROR_MESSAGE } from '../constant'
import { checkWarningCriteria, isArrayEqual } from '../helper'
import {
  changeErrors,
  selectErrors,
  selectOtherSetting,
  selectParamsRaw,
  selectSettingParams,
} from '../store/slice'
import { BeforeLeavePopup } from './BeforeLeavePopup'

export const Save = ({ createMode, onSave }) => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const detailProfileId = searchParams.get('profileId')
  const errors = useSelector(selectErrors())
  const profileAlertsName = useSelector(selectOtherSetting('profileName'))
  const allExistNames = useSelector(selectAllExistNames)
  const data = useSelector(selectProfileById(detailProfileId))
  const params = useSelector(selectSettingParams)
  const paramsRaw = useSelector(selectParamsRaw)

  const [isSettingChange, setIsSettingChange] = useState(false)

  const validate = () => {
    let isError = false
    const newErrors = JSON.parse(JSON.stringify(errors))

    const currentName = profileAlertsName?.trim()
    if (!currentName) {
      isError = true
      newErrors.profileAlertsName = ERROR_MESSAGE.PROFILE_ALERT_NAME_REQUIRED
    }
    if (
      (createMode && allExistNames.includes(currentName)) ||
      (!createMode &&
        currentName !== data?.profileName &&
        allExistNames.includes(currentName))
    ) {
      isError = true
      newErrors.profileAlertsName = ERROR_MESSAGE.PROFILE_ALERT_NAME_EXIST
    }

    if (isError) {
      dispatch(changeErrors(newErrors))

      const scrollDiv = document.querySelector(
        `#${CREATE_EDIT_PROFILE_SCROLL_ID} .scrollbars div:first-child`,
      )
      if (scrollDiv) {
        scrollDiv.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    }

    return isError
  }

  const handleSave = async () => {
    if (checkWarningCriteria(params.profileSettings)) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [<Translate value="alertSetting.WARNING_NO_CRITERIA" />],
      })
      return
    }
    const isError = validate()
    if (isError) return

    if (!createMode && !isSettingChange) return

    if (!createMode) {
      await AlertSettingService.updateProfileDetail({
        ...params,
        alertProfileId: detailProfileId,
      })
      dispatch(getAlertSettingsDynamic())
    } else {
      await AlertSettingService.createProfile(params).then(() => {
        dispatch(getAlertSettingsDynamic())
        onSave && onSave()
      })
      dispatch(getAlertSettingsDynamic())
    }
  }

  useEffect(() => {
    const { profileSettings: settingRaw, ...otherSettingRaw } = { ...paramsRaw }
    const { profileSettings: setting, ...otherSetting } = { ...params }

    if (Object.keys(paramsRaw).length) {
      const isOtherEqual = !isObjectEqual(otherSettingRaw, otherSetting)
      const isSettingEqual = !isArrayEqual(settingRaw, setting)
      setIsSettingChange(isSettingEqual || isOtherEqual)
    }
  }, [params])

  return (
    <>
      <Button
        label="common.SAVE"
        style={{
          border: 'none',
          backgroundColor: '#2c73e8',
          color: '#ffffff',
        }}
        action={handleSave}
        isI18n
      />

      <BeforeLeavePopup
        isBlock={!createMode && isSettingChange}
        handleSave={handleSave}
        validate={validate}
      />
    </>
  )
}
